// To learn more about as const, checkout https://youtu.be/jjMbPt_H3RQ
const AngloCityData = {
  "New York": { timezone: "America/New_York", lat: 40.7128, lon: -74.0060 },
  "San Francisco": {
    timezone: "America/Los_Angeles",
    lat: 37.7749,
    lon: -122.4194,
  },
  "Los Angeles": {
    timezone: "America/Los_Angeles",
    lat: 34.0522,
    lon: -118.2437,
  },
  "London": { timezone: "Europe/London", lat: 51.5074, lon: -0.1278 },
  "Seattle": { timezone: "America/Los_Angeles", lat: 47.6062, lon: -122.3321 },
  "Denver": { timezone: "America/Denver", lat: 39.7392, lon: -104.9903 },
  "Nashville": { timezone: "America/Chicago", lat: 36.1627, lon: -86.7816 },
  "Austin": { timezone: "America/Chicago", lat: 30.2672, lon: -97.7431 },
  "Chicago": { timezone: "America/Chicago", lat: 41.8781, lon: -87.6298 },
  "Portland": { timezone: "America/Los_Angeles", lat: 45.5122, lon: -122.6587 },
  "Boston": { timezone: "America/New_York", lat: 42.3601, lon: -71.0589 },
  "Las Vegas": {
    timezone: "America/Los_Angeles",
    lat: 36.1699,
    lon: -115.1398,
  },
  "Manchester": { timezone: "Europe/London", lat: 53.4808, lon: -2.2426 },
  "Philadelphia": { timezone: "America/New_York", lat: 39.9526, lon: -75.1652 },
  "Atlanta": { timezone: "America/New_York", lat: 33.7490, lon: -84.3880 },
  "New Orleans": { timezone: "America/Chicago", lat: 29.9511, lon: -90.0715 },
  "Minneapolis": { timezone: "America/Chicago", lat: 44.9778, lon: -93.2650 },
  "Detroit": { timezone: "America/New_York", lat: 42.3314, lon: -83.0458 },
  "Washington, D.C.": {
    timezone: "America/New_York",
    lat: 38.9072,
    lon: -77.0369,
  },
  "Richmond": { timezone: "America/New_York", lat: 37.5407, lon: -77.4360 },
  "Raleigh": { timezone: "America/New_York", lat: 35.7796, lon: -78.6382 },
  "Liverpool": { timezone: "Europe/London", lat: 53.4084, lon: -2.9916 },
  "Madison": { timezone: "America/Chicago", lat: 43.0731, lon: -89.4012 },
  "Miami": { timezone: "America/New_York", lat: 25.7617, lon: -80.1918 },
  "St. Louis": { timezone: "America/Chicago", lat: 38.6270, lon: -90.1994 },
  "Salt Lake City": {
    timezone: "America/Denver",
    lat: 40.7608,
    lon: -111.8910,
  },
  "Hartford": { timezone: "America/New_York", lat: 41.7658, lon: -72.6734 },
  "Charleston": { timezone: "America/New_York", lat: 32.7765, lon: -79.9311 },
  "Lincoln": { timezone: "America/Chicago", lat: 40.8136, lon: -96.7026 },
  "Omaha": { timezone: "America/Chicago", lat: 41.2565, lon: -95.9345 },
  "Memphis": { timezone: "America/Chicago", lat: 35.1495, lon: -90.0490 },
  "Berlin": { timezone: "Europe/Berlin", lat: 52.5200, lon: 13.4050 },
  "Paris": { timezone: "Europe/Paris", lat: 48.8566, lon: 2.3522 },
  "Toronto": { timezone: "America/Toronto", lat: 43.6510, lon: -79.3470 },
  "Vienna": { timezone: "Europe/Vienna", lat: 48.2082, lon: 16.3738 },
  "Leipzig": { timezone: "Europe/Berlin", lat: 51.3397, lon: 12.3731 },
  "Bologna": { timezone: "Europe/Rome", lat: 44.4949, lon: 11.3426 },
  "Montreal": { timezone: "America/Montreal", lat: 45.5017, lon: -73.5673 },
  "Dublin": { timezone: "Europe/Dublin", lat: 53.3498, lon: -6.2603 },
  "Baton Rouge": { timezone: "America/Chicago", lat: 30.4515, lon: -91.1871 },
  "Asheville": { timezone: "America/New_York", lat: 35.5951, lon: -82.5515 },
  "Athens": { timezone: "America/New_York", lat: 33.9519, lon: -83.3576 },
  "Jackson": { timezone: "America/Chicago", lat: 32.2988, lon: -90.1848 },
  "Taos": { timezone: "America/Denver", lat: 36.4072, lon: -105.5731 },
  "Birmingham": { timezone: "America/Chicago", lat: 33.5186, lon: -86.8104 },
  "Anchorage": { timezone: "America/Anchorage", lat: 61.2181, lon: -149.9003 },
  "Phoenix": { timezone: "America/Phoenix", lat: 33.4484, lon: -112.0740 },
  "Little Rock": { timezone: "America/Chicago", lat: 34.7465, lon: -92.2896 },
  "Wilmington": { timezone: "America/New_York", lat: 39.7391, lon: -75.5398 },
  "Honolulu": { timezone: "Pacific/Honolulu", lat: 21.3069, lon: -157.8583 },
  "Boise": { timezone: "America/Boise", lat: 43.6150, lon: -116.2023 },
  "Indianapolis": { timezone: "America/Indiana/Indianapolis", lat: 39.7684, lon: -86.1581 },
  "Des Moines": { timezone: "America/Chicago", lat: 41.5868, lon: -93.6250 },
  "Wichita": { timezone: "America/Chicago", lat: 37.6872, lon: -97.3301 },
  "Louisville": { timezone: "America/Kentucky/Louisville", lat: 38.2527, lon: -85.7585 },
  "Portland, Maine": { timezone: "America/New_York", lat: 43.6591, lon: -70.2568 },
  "Baltimore": { timezone: "America/New_York", lat: 39.2904, lon: -76.6122 },
  "Billings": { timezone: "America/Denver", lat: 45.7833, lon: -108.5007 },
  "Manchester, New Hampshire": { timezone: "America/New_York", lat: 42.9956, lon: -71.4548 },
  "Newark": { timezone: "America/New_York", lat: 40.7357, lon: -74.1724 },
  "Albuquerque": { timezone: "America/Denver", lat: 35.0844, lon: -106.6504 },
  "Charlotte": { timezone: "America/New_York", lat: 35.2271, lon: -80.8431 },
  "Fargo": { timezone: "America/Chicago", lat: 46.8772, lon: -96.7898 },
  "Cleveland": { timezone: "America/New_York", lat: 41.4993, lon: -81.6944 },
  "Oklahoma City": { timezone: "America/Chicago", lat: 35.4676, lon: -97.5164 },
  "Providence": { timezone: "America/New_York", lat: 41.8240, lon: -71.4128 },
  "Sioux Falls": { timezone: "America/Chicago", lat: 43.5446, lon: -96.7311 },
  "Houston": { timezone: "America/Chicago", lat: 29.7604, lon: -95.3698 },
  "Burlington": { timezone: "America/New_York", lat: 44.4759, lon: -73.2121 },
  "Charleston, West Virginia": { timezone: "America/New_York", lat: 38.3498, lon: -81.6326 },
  "Milwaukee": { timezone: "America/Chicago", lat: 43.0389, lon: -87.9065 },
  "Cheyenne": { timezone: "America/Denver", lat: 41.1400, lon: -104.8202 },
  "Canberra": { timezone: "Australia/Sydney", lat: -35.2809, lon: 149.1300 },
  "Sydney": { timezone: "Australia/Sydney", lat: -33.8688, lon: 151.2093 },
  "Newcastle": { timezone: "Australia/Sydney", lat: -32.9267, lon: 151.7789 },
  "Wollongong": { timezone: "Australia/Sydney", lat: -34.4278, lon: 150.8931 },
  "Brisbane": { timezone: "Australia/Brisbane", lat: -27.4698, lon: 153.0251 },
  "Gold Coast": { timezone: "Australia/Brisbane", lat: -28.0167, lon: 153.4000 },
  "Sunshine Coast": { timezone: "Australia/Brisbane", lat: -26.6500, lon: 153.0667 },
  "Adelaide": { timezone: "Australia/Adelaide", lat: -34.9285, lon: 138.6007 },
  "Melbourne": { timezone: "Australia/Melbourne", lat: -37.8136, lon: 144.9631 },
  "Perth": { timezone: "Australia/Perth", lat: -31.9505, lon: 115.8605 },
  "Calgary": { timezone: "America/Edmonton", lat: 51.0447, lon: -114.0719 },
  "Vancouver": { timezone: "America/Vancouver", lat: 49.2827, lon: -123.1207 },
  "Winnipeg": { timezone: "America/Winnipeg", lat: 49.8951, lon: -97.1384 },
  "Moncton": { timezone: "America/Moncton", lat: 46.0878, lon: -64.7782 },
  "St. John's": { timezone: "America/St_Johns", lat: 47.5615, lon: -52.7126 },
  "Halifax": { timezone: "America/Halifax", lat: 44.6488, lon: -63.5752 },
  "Charlottetown": { timezone: "America/Halifax", lat: 46.2382, lon: -63.1311 },
  "Saskatoon": { timezone: "America/Regina", lat: 52.1332, lon: -106.6700 },
  "Brussels": { timezone: "Europe/Brussels", lat: 50.8503, lon: 4.3517 },
  "Prague": { timezone: "Europe/Prague", lat: 50.0755, lon: 14.4378 },
  "Copenhagen": { timezone: "Europe/Copenhagen", lat: 55.6761, lon: 12.5683 },
  "Helsinki": { timezone: "Europe/Helsinki", lat: 60.1695, lon: 24.9354 },
  "Athens, Greece": { timezone: "Europe/Athens", lat: 37.9838, lon: 23.7275 },
  "Budapest": { timezone: "Europe/Budapest", lat: 47.4979, lon: 19.0402 },
  "Rome": { timezone: "Europe/Rome", lat: 41.9028, lon: 12.4964 },
  "Amsterdam": { timezone: "Europe/Amsterdam", lat: 52.3676, lon: 4.9041 },
  "Oslo": { timezone: "Europe/Oslo", lat: 59.9139, lon: 10.7522 },
  "Warsaw": { timezone: "Europe/Warsaw", lat: 52.2297, lon: 21.0122 },
  "Lisbon": { timezone: "Europe/Lisbon", lat: 38.7169, lon: -9.1399 },
  "Madrid": { timezone: "Europe/Madrid", lat: 40.4168, lon: -3.7038 },
  "Stockholm": { timezone: "Europe/Stockholm", lat: 59.3293, lon: 18.0686 },
  "Zurich": { timezone: "Europe/Zurich", lat: 47.3769, lon: 8.5417 },
  "Montgomery": { timezone: "America/Chicago", lat: 32.3792, lon: -86.3077 },
  "Fairbanks": { timezone: "America/Anchorage", lat: 64.8378, lon: -147.7164 },
  "Tucson": { timezone: "America/Phoenix", lat: 32.2226, lon: -110.9747 },
  "Fayetteville": { timezone: "America/Chicago", lat: 36.0822, lon: -94.1719 },
  "San Diego": { timezone: "America/Los_Angeles", lat: 32.7157, lon: -117.1611 },
  "Boulder": { timezone: "America/Denver", lat: 40.0150, lon: -105.2706 },
  "Dover": { timezone: "America/New_York", lat: 39.1582, lon: -75.5244 },
  "Tampa": { timezone: "America/New_York", lat: 27.9506, lon: -82.4572 },
  "Savannah": { timezone: "America/New_York", lat: 32.0809, lon: -81.0912 },
  "Coeur d’Alene": { timezone: "America/Los_Angeles", lat: 47.6777, lon: -116.7805 },
  "Springfield, Illinois": { timezone: "America/Chicago", lat: 39.7817, lon: -89.6501 },
  "Fort Wayne": { timezone: "America/Indiana/Indianapolis", lat: 41.0793, lon: -85.1394 },
  "Cedar Rapids": { timezone: "America/Chicago", lat: 41.9779, lon: -91.6656 },
  "Overland Park": { timezone: "America/Chicago", lat: 38.9822, lon: -94.6708 },
  "Lexington": { timezone: "America/New_York", lat: 38.0406, lon: -84.5037 },
  "Bangor": { timezone: "America/New_York", lat: 44.8012, lon: -68.7778 },
  "Annapolis": { timezone: "America/New_York", lat: 38.9784, lon: -76.4922 },
  "Worcester": { timezone: "America/New_York", lat: 42.2626, lon: -71.8023 },
  "Grand Rapids": { timezone: "America/Detroit", lat: 42.9634, lon: -85.6681 },
  "Biloxi": { timezone: "America/Chicago", lat: 30.3960, lon: -88.8853 },
  "Kansas City": { timezone: "America/Chicago", lat: 39.0997, lon: -94.5786 },
  "Missoula": { timezone: "America/Denver", lat: 46.8721, lon: -113.9940 },
  "Reno": { timezone: "America/Los_Angeles", lat: 39.5296, lon: -119.8138 },
  "Portsmouth": { timezone: "America/New_York", lat: 43.0718, lon: -70.7626 },
  "Jersey City": { timezone: "America/New_York", lat: 40.7178, lon: -74.0431 },
  "Buffalo": { timezone: "America/New_York", lat: 42.8864, lon: -78.8784 },
  "Bismarck": { timezone: "America/Chicago", lat: 46.8083, lon: -100.7837 },
  "Cincinnati": { timezone: "America/New_York", lat: 39.1031, lon: -84.5120 },
  "Tulsa": { timezone: "America/Chicago", lat: 36.1539, lon: -95.9928 },
  "Eugene": { timezone: "America/Los_Angeles", lat: 44.0521, lon: -123.0868 },
  "Pittsburgh": { timezone: "America/New_York", lat: 40.4406, lon: -79.9959 },
  "Newport": { timezone: "America/New_York", lat: 41.4901, lon: -71.3128 },
  "Greenville": { timezone: "America/New_York", lat: 34.8526, lon: -82.3940 },
  "Rapid City": { timezone: "America/Denver", lat: 44.0805, lon: -103.2310 },
  "Dallas": { timezone: "America/Chicago", lat: 32.7767, lon: -96.7970 },
  "Provo": { timezone: "America/Denver", lat: 40.2338, lon: -111.6585 },
  "Norfolk": { timezone: "America/New_York", lat: 36.8508, lon: -76.2859 },
  "Spokane": { timezone: "America/Los_Angeles", lat: 47.6588, lon: -117.4260 },
  "Morgantown": { timezone: "America/New_York", lat: 39.6295, lon: -79.9559 },
  "Casper": { timezone: "America/Denver", lat: 42.8501, lon: -106.3252 },
  "Edmonton": { timezone: "America/Edmonton", lat: 53.5461, lon: -113.4938 },
  "Victoria": { timezone: "America/Vancouver", lat: 48.4284, lon: -123.3656 },
  "Brandon": { timezone: "America/Winnipeg", lat: 49.8485, lon: -99.9501 },
  "Fredericton": { timezone: "America/Moncton", lat: 45.9636, lon: -66.6431 },
  "Corner Brook": { timezone: "America/St_Johns", lat: 48.9520, lon: -57.9331 },
  "Sydney, Nova Scotia": { timezone: "America/Halifax", lat: 46.1368, lon: -60.1942 },
  "Ottawa": { timezone: "America/Toronto", lat: 45.4215, lon: -75.6972 },
  "Summerside": { timezone: "America/Halifax", lat: 46.3926, lon: -63.7906 },
  "Quebec City": { timezone: "America/Toronto", lat: 46.8139, lon: -71.2082 },
  "Regina": { timezone: "America/Regina", lat: 50.4452, lon: -104.6189 },
  "Salzburg": { timezone: "Europe/Vienna", lat: 47.8095, lon: 13.0550 },
  "Antwerp": { timezone: "Europe/Brussels", lat: 51.2194, lon: 4.4025 },
  "Brno": { timezone: "Europe/Prague", lat: 49.1951, lon: 16.6068 },
  "Aarhus": { timezone: "Europe/Copenhagen", lat: 56.1629, lon: 10.2039 },
  "Tampere": { timezone: "Europe/Helsinki", lat: 61.4978, lon: 23.7610 },
  "Marseille": { timezone: "Europe/Paris", lat: 43.2965, lon: 5.3698 },
  "Hamburg": { timezone: "Europe/Berlin", lat: 53.5511, lon: 9.9937 },
  "Thessaloniki": { timezone: "Europe/Athens", lat: 40.6401, lon: 22.9444 },
  "Debrecen": { timezone: "Europe/Budapest", lat: 47.5316, lon: 21.6273 },
  "Cork": { timezone: "Europe/Dublin", lat: 51.8985, lon: -8.4756 },
  "Milan": { timezone: "Europe/Rome", lat: 45.4642, lon: 9.1900 },
  "Rotterdam": { timezone: "Europe/Amsterdam", lat: 51.9225, lon: 4.4792 },
  "Bergen": { timezone: "Europe/Oslo", lat: 60.3913, lon: 5.3221 },
  "Kraków": { timezone: "Europe/Warsaw", lat: 50.0647, lon: 19.9450 },
  "Porto": { timezone: "Europe/Lisbon", lat: 41.1496, lon: -8.6109 },
  "Barcelona": { timezone: "Europe/Madrid", lat: 41.3851, lon: 2.1734 },
  "Gothenburg": { timezone: "Europe/Stockholm", lat: 57.7089, lon: 11.9746 },
  "Geneva": { timezone: "Europe/Zurich", lat: 46.2044, lon: 6.1432 },
  "Huntsville": { timezone: "America/Chicago", lat: 34.7304, lon: -86.5861 },
  "Juneau": { timezone: "America/Juneau", lat: 58.3019, lon: -134.4197 },
  "Mesa": { timezone: "America/Phoenix", lat: 33.4152, lon: -111.8315 },
  "Colorado Springs": { timezone: "America/Denver", lat: 38.8339, lon: -104.8214 },
  "Stamford": { timezone: "America/New_York", lat: 41.0534, lon: -73.5387 },
  "Orlando": { timezone: "America/New_York", lat: 28.5383, lon: -81.3792 },
  "Augusta": { timezone: "America/New_York", lat: 33.4735, lon: -82.0105 },
  "Kailua-Kona": { timezone: "Pacific/Honolulu", lat: 19.6399, lon: -155.9969 },
  "Idaho Falls": { timezone: "America/Boise", lat: 43.4917, lon: -112.0331 },
  "Bloomington": { timezone: "America/Indiana/Indianapolis", lat: 39.1653, lon: -86.5264 },
  "Topeka": { timezone: "America/Chicago", lat: 39.0473, lon: -95.6752 },
  "Bowling Green": { timezone: "America/Chicago", lat: 36.9685, lon: -86.4808 },
  "Lafayette": { timezone: "America/Chicago", lat: 30.2241, lon: -92.0198 },
  "Augusta, Maine": { timezone: "America/New_York", lat: 44.3106, lon: -69.7795 },
  "Rockville": { timezone: "America/New_York", lat: 39.0837, lon: -77.1480 },
  "Springfield, Massachusetts": { timezone: "America/New_York", lat: 42.1015, lon: -72.5898 },
  "Ann Arbor": { timezone: "America/Detroit", lat: 42.2808, lon: -83.7430 },
  "Duluth": { timezone: "America/Chicago", lat: 46.7867, lon: -92.1005 },
  "Springfield, Missouri": { timezone: "America/Chicago", lat: 37.2089, lon: -93.2923 },
  "Great Falls": { timezone: "America/Denver", lat: 47.5053, lon: -111.3008 },
  "Grand Island": { timezone: "America/Chicago", lat: 40.9264, lon: -98.3420 },
  "Henderson": { timezone: "America/Los_Angeles", lat: 36.0395, lon: -114.9817 },
  "Concord": { timezone: "America/New_York", lat: 43.2081, lon: -71.5376 },
  "Atlantic City": { timezone: "America/New_York", lat: 39.3643, lon: -74.4229 },
  "Las Cruces": { timezone: "America/Denver", lat: 32.3199, lon: -106.7637 },
  "Albany": { timezone: "America/New_York", lat: 42.6526, lon: -73.7562 },
  "Durham": { timezone: "America/New_York", lat: 35.9940, lon: -78.8986 },
  "Grand Forks": { timezone: "America/Chicago", lat: 47.9253, lon: -97.0329 },
  "Columbus": { timezone: "America/New_York", lat: 39.9612, lon: -82.9988 },
  "Norman": { timezone: "America/Chicago", lat: 35.2220, lon: -97.4395 },
  "Salem": { timezone: "America/Los_Angeles", lat: 44.9429, lon: -123.0351 },
  "Allentown": { timezone: "America/New_York", lat: 40.6084, lon: -75.4902 },
  "Warwick": { timezone: "America/New_York", lat: 41.7001, lon: -71.4162 },
  "Columbia": { timezone: "America/New_York", lat: 34.0007, lon: -81.0348 },
  "Pierre": { timezone: "America/Chicago", lat: 44.3683, lon: -100.3510 },
  "Knoxville": { timezone: "America/New_York", lat: 35.9606, lon: -83.9207 },
  "Ogden": { timezone: "America/Denver", lat: 41.2230, lon: -111.9738 },
  "Rutland": { timezone: "America/New_York", lat: 43.6106, lon: -72.9726 },
  "Charlottesville": { timezone: "America/New_York", lat: 38.0293, lon: -78.4767 },
  "Parkersburg": { timezone: "America/New_York", lat: 39.2667, lon: -81.5615 },
  "Green Bay": { timezone: "America/Chicago", lat: 44.5192, lon: -88.0198 },
  "Laramie": { timezone: "America/Denver", lat: 41.3114, lon: -105.5911 },
  "Red Deer": { timezone: "America/Edmonton", lat: 52.2681, lon: -113.8112 },
  "Kelowna": { timezone: "America/Vancouver", lat: 49.8880, lon: -119.4960 },
  "Steinbach": { timezone: "America/Winnipeg", lat: 49.5258, lon: -96.6846 },
  "Saint John": { timezone: "America/Moncton", lat: 45.2736, lon: -66.0648 },
  "Gander": { timezone: "America/St_Johns", lat: 48.9562, lon: -54.6082 },
  "Truro": { timezone: "America/Halifax", lat: 45.3658, lon: -63.2860 },
  "Hamilton": { timezone: "America/Toronto", lat: 43.2557, lon: -79.8711 },
  "Stratford": { timezone: "America/Halifax", lat: 46.2207, lon: -63.0937 },
  "Gatineau": { timezone: "America/Toronto", lat: 45.4765, lon: -75.7013 },
  "Prince Albert": { timezone: "America/Regina", lat: 53.2033, lon: -105.7531 },
  "Graz": { timezone: "Europe/Vienna", lat: 47.0707, lon: 15.4395 },
  "Ghent": { timezone: "Europe/Brussels", lat: 51.0543, lon: 3.7174 },
  "Ostrava": { timezone: "Europe/Prague", lat: 49.8209, lon: 18.2625 },
  "Odense": { timezone: "Europe/Copenhagen", lat: 55.4038, lon: 10.4024 },
  "Turku": { timezone: "Europe/Helsinki", lat: 60.4518, lon: 22.2666 },
  "Lyon": { timezone: "Europe/Paris", lat: 45.7640, lon: 4.8357 },
  "Munich": { timezone: "Europe/Berlin", lat: 48.1351, lon: 11.5820 },
  "Patras": { timezone: "Europe/Athens", lat: 38.2466, lon: 21.7346 },
  "Szeged": { timezone: "Europe/Budapest", lat: 46.2530, lon: 20.1414 },
  "Galway": { timezone: "Europe/Dublin", lat: 53.2707, lon: -9.0568 },
  "Florence": { timezone: "Europe/Rome", lat: 43.7696, lon: 11.2558 },
  "Utrecht": { timezone: "Europe/Amsterdam", lat: 52.0907, lon: 5.1214 },
  "Trondheim": { timezone: "Europe/Oslo", lat: 63.4305, lon: 10.3951 },
  "Wrocław": { timezone: "Europe/Warsaw", lat: 51.1079, lon: 17.0385 },
  "Faro": { timezone: "Europe/Lisbon", lat: 37.0194, lon: -7.9304 },
  "Valencia": { timezone: "Europe/Madrid", lat: 39.4699, lon: -0.3763 },
  "Malmö": { timezone: "Europe/Stockholm", lat: 55.6049, lon: 13.0038 },
  "Basel": { timezone: "Europe/Zurich", lat: 47.5596, lon: 7.5886 },
  "Birmingham, United Kingdom": { timezone: "Europe/London", lat: 52.4862, lon: -1.8904 },
  "Fort Collins": { timezone: "America/Denver", lat: 40.5853, lon: -105.0844 },
  "San Antonio": { timezone: "America/Chicago", lat: 29.4241, lon: -98.4936 },
  "Sacramento": { timezone: "America/Los_Angeles", lat: 38.5816, lon: -121.4944 },
} as const;

// @FIX this info should really be in the datamodel?
const EuroCityData = {
  "Berlin": { timezone: "Europe/Berlin", lat: 52.5200, lon: 13.4050 },
  "Paris": { timezone: "Europe/Paris", lat: 48.8566, lon: 2.3522 },
  "Toronto": { timezone: "America/Toronto", lat: 43.6510, lon: -79.3470 },
  "Vienna": { timezone: "Europe/Vienna", lat: 48.2082, lon: 16.3738 },
  "Leipzig": { timezone: "Europe/Berlin", lat: 51.3397, lon: 12.3731 },
  "Bologna": { timezone: "Europe/Rome", lat: 44.4949, lon: 11.3426 },
  "Montreal": { timezone: "America/Montreal", lat: 45.5017, lon: -73.5673 },
  "Dublin": { timezone: "Europe/Dublin", lat: 53.3498, lon: -6.2603 },
} as const;

const AllCityData = { ...AngloCityData, ...EuroCityData };

export type AngloCity = keyof typeof AngloCityData;
export type AnyCity = keyof typeof AllCityData;
export type Timezone = typeof AllCityData[AnyCity]["timezone"];
// export type CityInfo = typeof AngloCityData[AngloCity];

const supportedAngloCities = Object.keys(AngloCityData) as AngloCity[];

function getTimezone(city: AnyCity): Timezone {
  // Fallback to New York. Used in cases where there is no metro, i.e in some artist profiles. This seems to work fine for European Shows mostly. This is going to come back to bite me.
  return AllCityData[city]?.timezone || "America/New_York";
}

// Haversine formula to calculate the distance between two points on a sphere
function haversine(lat1: number, lon1: number, lat2: number, lon2: number) {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // Distance in km
}

function deg2rad(deg: number) {
  return deg * (Math.PI / 180);
}

function getClosestCity(latitude: number, longitude: number): AngloCity | null {
  // Check for invalid input
  if (
    latitude === null || longitude === null || isNaN(latitude) ||
    isNaN(longitude)
  ) {
    throw new Error(
      "Invalid coordinates: latitude and longitude must be numbers.",
    );
  }

  // Check for out-of-bounds coordinates
  if (latitude < -90 || latitude > 90 || longitude < -180 || longitude > 180) {
    throw new Error(
      "Invalid coordinates: latitude must be between -90 and 90, longitude must be between -180 and 180.",
    );
  }

  let closestCity = null;
  let minDistance = Infinity;
  for (const supportedCity of supportedAngloCities) {
    const { lat, lon } = AngloCityData[supportedCity];
    const distance = haversine(latitude, longitude, lat, lon);
    if (distance < minDistance) {
      minDistance = distance;
      closestCity = supportedCity;
    }
  }
  return closestCity;
}

export { getClosestCity, getTimezone, supportedAngloCities as supportedCities };
